import flatTire from '../assets/rsa/flat tyre.png'
import fuelAssistance from '../assets/rsa/fuel assistance.png'
import towing from '../assets/rsa/towing.png'
import spareKeys from '../assets/rsa/spare keys.png'
import batteryJumpstart from '../assets/rsa/battery jumpstart.png'
import minorRepairs from '../assets/rsa/minor repair.png'
import batteryIssues from '../assets/rsa/battery issues.png'


const roadsideAssistance = [
    {
        icon: flatTire,
        name: 'Flat Tire'
    },
    {
        icon: fuelAssistance,
        name: 'Fuel Assistance'
    },
    {
        icon: towing,
        name: 'Towing'
    },
    {
        icon: spareKeys,
        name: 'Spare Keys'
    },
    {
        icon: batteryJumpstart,
        name: 'Battery Jumpstart'
    },
    {
        icon: minorRepairs,
        name: 'Minor Repairs'
    },
    {
        icon: batteryIssues,
        name: 'Battery Issues'
    }
]

export default roadsideAssistance;
